function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { func, arrayOf, number, object } from 'prop-types';
import { styled } from '@mui/material/styles';
import { tabBarPadding } from '../../internals/page-layout/contentPadding';
import SovosTabs from '../../sovos-tabs';
import SovosTab from '../../sovos-tab';
var Root = styled(SovosTabs)(function (_ref) {
  var _ref$theme = _ref.theme,
    breakpoints = _ref$theme.breakpoints,
    palette = _ref$theme.palette,
    spacing = _ref$theme.spacing;
  return _objectSpread(_objectSpread({}, tabBarPadding(breakpoints, spacing)), {}, {
    backgroundColor: palette.background.default,
    padding: "0 ".concat(spacing(2)),
    zIndex: 20
  });
});
var TabBar = function TabBar(_ref2) {
  var onTabClick = _ref2.onTabClick,
    selectedTab = _ref2.selectedTab,
    tabsData = _ref2.tabsData;
  function renderTab(tab, index) {
    return /*#__PURE__*/React.createElement(SovosTab, {
      key: "Tab".concat(index, "-").concat(tab.label),
      icon: tab.icon,
      label: tab.label,
      value: index
    });
  }
  return /*#__PURE__*/React.createElement(Root, {
    className: "sovosPageLayout__tabBar",
    onChange: onTabClick,
    value: selectedTab
  }, tabsData.map(renderTab));
};
TabBar.propTypes = {
  onTabClick: func.isRequired,
  selectedTab: number.isRequired,
  tabsData: arrayOf(object).isRequired
};
export default TabBar;